import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const AccountDelete = {
  namespaced: true,
  state: {
    user_data: []
  },
  getters: {
    user_data: state => state.user_data
  },
  mutations: {
    UPDATE_ACCOUNT_DELETE(state, payload) {
      state.user_data = payload['user_data']
    }
  },
  actions: {
    async actionFetchAccountDelete({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '' && token !== undefined) {
        res = await APIClient.postAccountDelete(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_ACCOUNT_DELETE', res.data.data)
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
